var mapbox = {
    init: function() {
        if ( typeof mapboxData !== "undefined" && mapboxData.hasOwnProperty( 'accessToken' ) ) {
            mapboxgl.accessToken = mapboxData.accessToken;

    		var map = new mapboxgl.Map( {
    			container: 'map',
    			style: 'mapbox://styles/bicepsdigital/cjvz0jypi032c1cp59j2ap3em',
    			center: [16.877522888881, 49.876935207975],
                zoom: 15,
                attributionControl: false,
                scrollZoom: false,
                boxZoom: false
    		} );

            if ( mapboxData.hasOwnProperty( 'markers' ) ) {
                var markers = mapboxData.markers,
                bounds      = []; 

                for ( var marker in markers ) {
                    var markerData = markers[marker],
                    markerEl = document.createElement('div');
                    markerEl.className = 'map__marker';

                    new mapboxgl.Marker(markerEl, { offset: [0, -32] })
                        .setLngLat([ markerData.lng, markerData.lat ])
                        .addTo(map);
                };
            }
        }
    }
}

export { mapbox };